import { CONST_ROWS_PER_PAGE } from '@commons/consts';
import {
    NEW_CONTROLE_CONTA_CAIXA_SUCCESS,
    LIST_CONTROLE_CONTA_CAIXA_PENDING,
    LIST_CONTROLE_CONTA_CAIXA_SUCCESS,
    LIST_CONTROLE_CONTA_CAIXA_FAILURE,
    FIND_CONTROLE_CONTA_CAIXA_PENDING,
    FIND_CONTROLE_CONTA_CAIXA_SUCCESS,
    FIND_CONTROLE_CONTA_CAIXA_FAILURE,
    DELETE_CONTROLE_CONTA_CAIXA_PENDING,
    DELETE_CONTROLE_CONTA_CAIXA_SUCCESS,
    DELETE_CONTROLE_CONTA_CAIXA_FAILURE,
    CREATE_CONTROLE_CONTA_CAIXA_PENDING,
    CREATE_CONTROLE_CONTA_CAIXA_SUCCESS,
    CREATE_CONTROLE_CONTA_CAIXA_FAILURE,
    NEW_FILTER_NEXT_PAGE_CONTROLE_CONTA_CAIXA_PENDING,
    NEW_FILTER_NEXT_PAGE_CONTROLE_CONTA_CAIXA_SUCCESS,
    NEW_FILTER_NEXT_PAGE_CONTROLE_CONTA_CAIXA_FAILURE,
    NEW_FILTER_CONTROLE_CONTA_CAIXA_PEDING,
    NEW_FILTER_CONTROLE_CONTA_CAIXA_SUCCESS,
    NEW_FILTER_CONTROLE_CONTA_CAIXA_FAILURE,
    GET_TOTAIS_CONTROLE_CONTA_CAIXA_PENDING,
    GET_TOTAIS_CONTROLE_CONTA_CAIXA_SUCCESS,
    GET_TOTAIS_CONTROLE_CONTA_CAIXA_FAILURE,
    NEW_FILTER_CONTROLE_CONTA_CAIXA_SUCCESS_PDF,
} from './actionTypes';

const initialState = {
    list: null,
    loading: false,
    loadingTotais: false,
    filter: { rows: CONST_ROWS_PER_PAGE, page: 0, where: '' },
    totais: {
        totalSadoAnterior: 0,
        totalEntrada: 0,
        totalSaida: 0,
        totalFinal: 0
    }
}

function controleContaCaixaReducer(state = initialState, action) {

    switch (action.type) {
        case NEW_CONTROLE_CONTA_CAIXA_SUCCESS:
            return {
                ...state,
                loading: false,
                registro: action.registro
            }
        case LIST_CONTROLE_CONTA_CAIXA_PENDING:
        case FIND_CONTROLE_CONTA_CAIXA_PENDING:
        case DELETE_CONTROLE_CONTA_CAIXA_PENDING:
        case CREATE_CONTROLE_CONTA_CAIXA_PENDING:
            case NEW_FILTER_CONTROLE_CONTA_CAIXA_PEDING:
            case NEW_FILTER_NEXT_PAGE_CONTROLE_CONTA_CAIXA_PENDING:
            return {
                ...state,
                loading: true,
            }
        // %%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%
        case LIST_CONTROLE_CONTA_CAIXA_SUCCESS:
            return {
                ...state,
                list: action.list,
                newFilter: action.newFilter,
                loading: false
            }
        case LIST_CONTROLE_CONTA_CAIXA_FAILURE:
            return {
                ...state,
                list: null,
                loading: false
            }
        // %%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%
        case FIND_CONTROLE_CONTA_CAIXA_SUCCESS:
            return {
                ...state,
                registro: action.registro,
                loading: false
            }
        case FIND_CONTROLE_CONTA_CAIXA_FAILURE:
            return {
                ...state,
                registro: null,
                loading: false
            }
        // %%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%
        case DELETE_CONTROLE_CONTA_CAIXA_SUCCESS: {
            return {
                ...state,
                loading: false
            }
        }
        // %%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%
        case GET_TOTAIS_CONTROLE_CONTA_CAIXA_PENDING:
            return {
                ...state,
                loadingTotais: true,
            }
        case GET_TOTAIS_CONTROLE_CONTA_CAIXA_SUCCESS:
            return {
                ...state,
                totais: action.totais,
                loadingTotais: false
            }
        case GET_TOTAIS_CONTROLE_CONTA_CAIXA_FAILURE:
            return {
                ...state,
                totais: {
                    totalSadoAnterior: 0,
                    totalEntrada: 0,
                    totalSaida: 0,
                    totalFinal: 0
                },
                loadingTotais: false
            }
        // %%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%
        case NEW_FILTER_NEXT_PAGE_CONTROLE_CONTA_CAIXA_SUCCESS:
            return {
                ...state,
                list: action.list,
                filter: action.filter,
                loading: false
            }
        case NEW_FILTER_NEXT_PAGE_CONTROLE_CONTA_CAIXA_FAILURE:
            return {
                ...state,
                list: null,
                loading: false
            }
        // %%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%
        case NEW_FILTER_CONTROLE_CONTA_CAIXA_SUCCESS: {
            return {
                ...state,
                list: action.list,
                filter: action.filter,
                loading: false
            }
        }
        case NEW_FILTER_CONTROLE_CONTA_CAIXA_SUCCESS_PDF:
        case NEW_FILTER_CONTROLE_CONTA_CAIXA_FAILURE: {
            return {
                ...state,
                loading: false
            }
        }
        // %%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%
        case CREATE_CONTROLE_CONTA_CAIXA_SUCCESS:
        case CREATE_CONTROLE_CONTA_CAIXA_FAILURE:
            return {
                ...state,
                loading: false,
                registro: action.registro
            }
        case DELETE_CONTROLE_CONTA_CAIXA_FAILURE:
            return {
                ...state,
                loading: false,
            }
        // %%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%
        default:
            return state
    }
}

export { controleContaCaixaReducer };